<h2>Récapitulatifs des ventes</h2>
    <app-gmao-spinner *ngIf="!stats"></app-gmao-spinner>
    <br>
    <ng-container *ngIf="stats">
    <app-export-button [data]="stats.stats2"></app-export-button>
    
    <br>
    <form (ngSubmit)="onFilterDept()" [formGroup]="form" >
        <h5>Filtres</h5>
        <mat-form-field>
            <mat-label>Département</mat-label>
            <mat-select multiple formControlName="dept">
                <mat-option *ngFor="let departement of departements" [value]="departement">{{departement}}</mat-option>
            </mat-select>
        </mat-form-field>

        <button type="submit" class="btn btn-secondary submit">Appliquer</button>
    </form>
    <button class="btn btn-primary" (click)="deselectAll()">Réinitialiser</button>
    <br>
</ng-container>

<div class="test" *ngIf="stats">
    <table class="table table-bordered table-sm" id="tableStats">
        <thead>
            <tr>
                <!--Chaque colonne est cliquable pour permettre le tri-->
                <th colspan="4" class="center">Infos</th>
                <th colspan="7" class="center">Totaux</th>
                <th colspan="4" class="center">28 jours</th>
                <th colspan="14" class="center">Derniers jours</th>
            </tr>
            <tr>
                <!--Chaque colonne est cliquable pour permettre le tri-->
                <th (click)="sortColumn('nom_installation')" class="colonneInstallation">Installation</th>
                <th (click)="sortColumn('departement')">Dept</th>
                <!--Numéro de département de l'installation-->
                <th (click)="sortColumn('age')">Age</th>
                <!--Numéro de serie de l'installation-->
                <th (click)="sortColumn('numero_serie')">N° serie</th>
                <!--Nombre de jours depuis l'installation du DAP-->
                <th (click)="sortColumn('ca_ttc')">CA TTC</th>
                <!--CA total depuis l'installation-->
                <th (click)="sortColumn('pizzas_vendues_count')">Pizzas</th>
                <!--Nombre de pizzas vendu depuis l'installation-->
                <th (click)="sortColumn('pizzas_vendues_froides_pc')">Froides(%)</th>
                <!--Part des pizzas froides dans la totalité des ventes-->
                <th (click)="sortColumn('moy_pizzas_vendues_count')">Pizzas/j.</th>
                <th (click)="sortColumn('moy_ca_ttc')">CA/j</th>
                <th (click)="sortColumn('prix_moyen_pizzas')">Prix</th>
                <th (click)="sortColumn('rg_pannes_pcp')">Pan.</th>
                <th (click)="sortColumn('moy_ca_ttc_28')">Moy CA/j 28</th> <!-- ???? CLASSEMENT PAR DEFAUT -->
                <th (click)="sortColumn('moy_pizzas_vendues_count_28')" class="moyenneCA28">Moy Pizzas 28</th> <!-- ???? -->
                <th (click)="sortColumn('prix_moyen_28')">Prix 28</th> <!-- ???? -->
                <th (click)="sortColumn('rg_pannes_pcp_28')">Pan. 28</th> <!-- ???? -->
                <ng-container *ngFor="let jours of listeDates; let index = index">
                    <th (click)="sortJoursValues('ventes', index)">{{ jours }} </th>
                </ng-container>
            </tr>
        </thead>

        <tbody>
                <!--Début boucle lignes-->
                <tr *ngFor="let machine of filteredStat">
                    <td class="colonneInstallation">

                        <ng-container>
                            <a [routerLink] ="['/installation', machine.id_installation]">{{  machine.nom_installation  }}</a>
                        </ng-container>
                        <!--Lien vers la page du DAP-->
                    </td>
                    <td>{{ machine.departement }}</td>
                    <td>{{ machine.age }}</td>
                    <td>{{ machine.numero_serie }}</td>
                    <td [ngClass]="getCaTTCColor(machine.ca_ttc)">{{ separateThousands(displayIntegerValue( machine.ca_ttc )) }}</td>
                    <td [ngClass]="{
                    'verygood' : machine.pizzas_commandees_count >10000,
                    'good' : machine.pizzas_commandees_count >8000 && machine.pizzas_commandees_count <=10000,
                    'warning' : machine.pizzas_commandees_count>3500 && machine.pizzas_commandees_count <=8000,
                    'verywarning' : machine.pizzas_commandees_count>3000 && machine.pizzas_commandees_count <=8000,
                    'alert' : machine.pizzas_commandees_count>2000 && machine.pizzas_commandees_count<=3000,
                    'veryalert' : machine.pizzas_commandees_count>1500 && machine.pizzas_commandees_count<=2000,
                    'bad' : machine.pizzas_commandees_count>800 && machine.pizzas_commandees_count<=1500,
                    'verybad' : machine.pizzas_commandees_count<=800
                }">{{ separateThousands( machine.pizzas_commandees_count ) }}</td>
                    <td>{{ machine.pizzas_vendues_froides_pc }}</td>
                    <td [ngClass]="getMoyennePizzasVenduesColor(machine.moy_pizzas_vendues_count)">{{
                        machine.moy_pizzas_vendues_count }}</td>
                    <td [ngClass]="getMoyenneCATTCColor(machine.moy_ca_ttc)">{{ machine.moy_ca_ttc }}</td>
                    <td>{{ machine.prix_moyen_pizzas }}</td>
                    <td [ngClass]="getRegPanneColor(machine.rg_pannes_pcp)">{{ machine.rg_pannes_pcp }}</td>
                    <td [ngClass]="getMoyenneCATTC28Color(machine.moy_ca_ttc_28)" class="moyenneCA28">{{ machine.moy_ca_ttc_28 }}</td>
                    <td>{{ machine.moy_pizzas_vendues_count_28 }}</td>
                    <td>{{ machine.prix_moyen_28 }}</td>
                    <td>{{machine.rg_pannes_pcp_28 }}</td>

                    <ng-container *ngFor="let ventesJour of machine.ventes">
                        <td *ngIf="ventesJour > -1" [ngClass]="{
                        'verygood' : ventesJour >50,
                        'good' : ventesJour >40 && ventesJour <=50,
                        'warning' : ventesJour>30 && ventesJour <=40,
                        'verywarning' : ventesJour>25 && ventesJour <=30,
                        'alert' : ventesJour>15 && ventesJour<=25,
                        'veryalert' : ventesJour>10 && ventesJour<=15,
                        'bad' : ventesJour>5 && ventesJour<=10,
                        'verybad' : ventesJour<=5               
                    }">{{ventesJour}}</td>
                        <td *ngIf="ventesJour < 0">&nbsp;</td>
                    </ng-container>
                </tr>
                <!--Fin de boucle ligne-->

        </tbody>
    </table>
</div>